export default __webpack_public_path__ + "static/media/show-earring-1.8ac770ac.webp";